import apiDocument from '@/api/documents'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createDocumentStart: '[create documents] Create documents start',
  createDocumentSuccess: '[create documents] Create documents success',
  createDocumentFailure: '[create documents] Create documents failure',
}

export const actionTypes = {
  createDocument: '[create documents] Create documents',
}

const mutations = {
  [mutationTypes.createDocumentStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createDocumentSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createDocumentFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createDocument](context, {athleteId, document}) {
    context.commit(mutationTypes.createDocumentStart)
    return new Promise((resolve) => {
      apiDocument
        .createAthleteDocuments(athleteId, document)
        .then((response) => {
          context.commit(mutationTypes.createDocumentSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createDocumentFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
